import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { ClassroomStore } from 'src/app/stores/enrollment/classroom.store';
import { ConfigStore } from 'src/app/stores/config.store';

@Component({
  selector: 'app-classroom-panel',
  templateUrl: './classroom-panel.component.html',
  styleUrls: ['./classroom-panel.component.scss']
})
export class ClassroomPanelComponent implements OnInit {
  LOADING: boolean = true;
  SELECTED_TERM: any = null;
  SELECTED_CLASS: any = null;
  ID: any;

  constructor(
    private config: ConfigStore,
    private route: ActivatedRoute,
    private router: Router,
    public store: ClassroomStore,
    public dialog: MatDialog) { }

  async ngOnInit() {
    this.LOADING = true;
    this.route.params.subscribe(async params => {
      const { id } = params;
      this.ID = id;
      const doc = await this.store.fetchClassroom(id);
      if (!doc) {
        this.router.navigate(['/404'])
        return;
      }
      this.SELECTED_CLASS = doc;
      this.SELECTED_TERM = await this.config.fetchTerm()
      this.LOADING = false;
    })
  }

  _goBack() {
    this.router.navigate(['/enrollment/classrooms/submitted'])
  }

}
